globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Sponsoring = appCustomerSpace.Controllers.Sponsoring || {};

appCustomerSpace.Controllers.Sponsoring.ManageController = (function(superClass) {

    utils.extend(ManageController, superClass);

    function ManageController() {
      return ManageController.__super__.constructor.apply(this, arguments);
    }

    $.extend(ManageController.prototype, {
      init: function(){
        appCustomerSpace.Modules.InputPhone.init($('#sponsoring-solution-1'));
        this.byDirectForm();
        this.byEmailOrSms();
        this.bySocials();

        return ManageController.__super__.init.apply(this, arguments);
      },
      byDirectForm : function() {
        var controller = this,
            $forms_wrapper = controller.$body.find('#sponsoring-solution-1'),
            $submit_forms_button = $forms_wrapper.find('button.submit-forms'),
            $icon = $submit_forms_button.find('i'),
            $buttonText = $submit_forms_button.find('span'),
            defaultButtonText = $buttonText.text(),
            defaultIconClassList = $icon[0].classList.value;


        var displayError = function($form_group, bool, error) {
          if(bool) {
            $form_group.addClass('has-error').append($("<div class='form-control-feedback'><i class='icon icon-cancel-circle2'></i></div>"));
            if(error) {
              $form_group.append($('<div class="validation-error-label" style="font-size:11px;">'+error+'</div>'))
            }
          } else {
            $form_group.removeClass('has-error').find('.form-control-feedback, .validation-error-label').remove();
          }
        }

        var submitButtonState = function(state){
          switch(state) {
              case 'default':
                $buttonText.text(defaultButtonText);
                $icon[0].classList.value = defaultIconClassList;
                $submit_forms_button.removeClass('btn-success').addClass('btn-primary');
              break;
              case 'submitting':
                $icon[0].classList.value = 'icon-spinner4 spinner position-left';
                $submit_forms_button.find('span').text('Soumission en cours...').end();
              break;
              case 'success':
                $submit_forms_button.removeClass('btn-primary').addClass('btn-success');
                $buttonText.text("Invations envoyées !");
                $icon[0].classList.value = "icon-check position-left";
              break;
              case 'error':
                submitButtonState('default');
              break;
          }
        }

        $forms_wrapper.on('change', '.form-control', function(){
          var $this = $(this),
              $form_group = $this.closest('.form-group'),
              $form = $this.closest('form');

          $form.addClass('changed');

          if($this.hasClass('required')) {
            if($this.val() == "") {
              displayError($form_group, true);
            } else {
              displayError($form_group, false);
            }
          }

          if($forms_wrapper.find('.form-group.has-error').length) {
            displayError($form_group);
          }
        });

        $forms_wrapper.on('click', 'button.add-lead-row', function(){
          $.ajax({
            url: helpers.routes.sponsoring.add_lead_row_path,
            method: 'POST',
            data: {index: $forms_wrapper.find('form').length},
            success: function(data){
              if(data.response) {
                var $new_row = $(data.view);
                $new_row.hide();
                $forms_wrapper.find('form').last().after($new_row);
                $new_row.fadeIn();
                $forms_wrapper.find('form').last().find('.form-control').first().focus();
              } else {
                console.log("Une erreur s'est produite");
              }
            },
            error: function(data){
              alert('Une erreur est survenue');
            }
          });
        });

        $submit_forms_button.on('click', function(){
          // Prevent submit if all forms are empty
          if(!$forms_wrapper.find('form.changed').length) {
            $forms_wrapper.find('form .form-control').first().focus();
            return;
          }

          // Display errors if some required fields are empty
          $forms_wrapper.find('form.changed .form-control.required').each(function(){
            if($(this).val() == "") displayError($(this).closest('.form-group'), true);
          });

          // Prevent submit if forms contain errors
          if($forms_wrapper.find('form.changed .form-group.has-error').length) {
            submitButtonState('error');
            return;

          // Submit to server if all conditions are fulfilled
          } else {
            submitButtonState('submitting');
            $forms_wrapper.find('form.changed').each(function(){
              var $form = $(this);
              $.ajax({
                url: helpers.routes.sponsoring.create_lead_path,
                method: 'POST',
                data: $form.serialize(),
                success: function(data){
                  if(data.response) {
                    $form.addClass('submitted').removeClass('changed').find('input').val('');
                    $form.find('.iti').hide();
                    submitButtonState('success');
                    setTimeout(function(){
                      submitButtonState('default');
                      $form.removeClass('submitted');
                      $form.find('.iti').show();
                    }, 2000);
                  } else {
                    submitButtonState('error');
                    $.each(data.errors, function(attr, error){
                      displayError($form.find('.form-control[name="contact['+attr+']"]').closest('.form-group'), true, error);
                    });
                  }
                },
                error: function(data){ alert('Une erreur est survenue'); }
              });
            });
          }
        });
      },
      byEmailOrSms : function() {
        appCustomerSpace.ModalShareBySmsOrEmail.listen();
      },
      bySocials : function() {
        var controller = this;

        // Facebook share
        window.fbAsyncInit = function(){
          FB.init({appId: '682082981825847', status: true, cookie: true, xfbml: true });
        };

        (function(d, debug){var js, id = 'facebook-jssdk', ref = d.getElementsByTagName('script')[0];
            if(d.getElementById(id)) {return;}
            js = d.createElement('script'); js.id = id;
            js.async = true;js.src = "//connect.facebook.net/en_US/all" + (debug ? "/debug" : "") + ".js";
            ref.parentNode.insertBefore(js, ref);}(document, /*debug*/ false));

        controller.$body.find('button.share-on-facebook').click(function(){
          og = $(this).data('og');
          FB.ui({
            method: "feed",
            title: og.title,
            description: og.description,
            link: og.link,
            picture: og.image.url,
            hashtag: "#Simplébo"
          }, function(){});

          return false;
        });
      }
    });

    return ManageController;

})(appCustomerSpace.Controllers.Sponsoring.MainController);
